import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { connect } from 'react-redux';
import { Table, Icon, Spin } from 'antd';
import { TitleText, BasicText, ShortInput, LongInput, CopyUrl, BasicButton } from '@components';
import styles from './UserHome.module.css';
import BlockButton from '@users/BlockButton';
import DeleteButton from '@users/DeleteButton';
import { showSuccessMessage } from '@global';

const UserTable = ({ users, blockUser, unBlockUser }) => {
  const getUserTableData = () => {
    let dataArray = [];
    users.forEach((user, i) => {
      dataArray.push({
        id: user.id,
        full_name: user.full_name,
        email: user.email,
        username: user.username,
        last_opened: user.last_opened,
        entry_count: user.entry_count,
        follower_count: user.follower_count,
        following_count: user.following_count,
        group_count: user.group_count,
        photo_url: user.photo_url,
        joined: user.joined,
        books_finished: user.books_finished,
        review_count: user.review_count,
        reading_books: user.reading_books,
        is_blocked: user.is_blocked
      })
    });
    return dataArray;
  }

  const getColumns = () => {
    let columns = [
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>User</div>;
        },
        dataIndex: 'full_name',
        key: 'full_name',
        width: 150,
        render(text, record) {
          return {
            children: <CopyToClipboard
                        text={record.email}
                        onCopy={(text) => showSuccessMessage(`Copied "${record.email}" to clipboard.`)}
                      >
                        <div
                          style={{
                              display: "flex",
                              alignItems: 'center',
                              maxWidth: 150,
                              overflow: 'hidden',
                              cursor: 'pointer'
                            }}
                            onClick={() => console.log("clicked")}
                          >
                          <img src={record.photo_url} style={{ width: 30, height: 30, borderRadius: 6, marginRight: 12 }} />
                          <div>
                            <BasicText fontSize="11px" bold>{text}</BasicText>
                            <BasicText fontSize="9px">{record.email}</BasicText>
                          </div>
                        </div>
                      </CopyToClipboard>
          };
        }
      },
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>Username</div>;
        },
        dataIndex: 'username',
        key: 'username',
        width: 90,
        render(text, record) {
          return {
            children: <div style={{ maxWidth: 90, overflow: 'hidden' }}>
                        <BasicText fontSize="10px">{text}</BasicText>
                      </div>,
          };
        }
      },
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>Last Opened</div>;
        },
        dataIndex: 'last_opened',
        key: 'last_opened',
        width: 120,
        render(text, record) {
          return {
            children: <BasicText fontSize="10px">{text}</BasicText>,
          };
        }
      },
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>Joined</div>;
        },
        dataIndex: 'joined',
        key: 'joined',
        width: 90,
        render(text, record) {
          return {
            children: <BasicText fontSize="10px">{text}</BasicText>,
          };
        }
      },
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>Total Entries</div>;
        },
        dataIndex: 'entry_count',
        key: 'entry_count',
        width: 90,
        render(text, record) {
          return {
            children: <BasicText fontSize="10px">{text}</BasicText>,
          };
        }
      },
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>Finished Books</div>;
        },
        dataIndex: 'books_finished',
        key: 'books_finished',
        width: 90,
        render(text, record) {
          return {
            children: <BasicText fontSize="10px">{text}</BasicText>,
          };
        }
      },
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>Reading Books</div>;
        },
        dataIndex: 'reading_books',
        key: 'reading_books',
        width: 90,
        render(text, record) {
          return {
            children: <BasicText fontSize="10px">{text}</BasicText>,
          };
        }
      },
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>Reviews</div>;
        },
        dataIndex: 'review_count',
        key: 'review_count',
        width: 90,
        render(text, record) {
          return {
            children: <BasicText fontSize="10px">{text}</BasicText>,
          };
        }
      },
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>Followers/ Following</div>;
        },
        dataIndex: 'follower_count',
        key: 'follower_count',
        width: 90,
        render(text, record) {
          return {
            children: <BasicText fontSize="10px">{record.follower_count} / {record.following_count}</BasicText>,
          };
        }
      },
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>Groups</div>;
        },
        dataIndex: 'group_count',
        key: 'group_count',
        width: 80,
        render(text, record) {
          return {
            children: <BasicText fontSize="10px">{text}</BasicText>,
          };
        }
      },
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>Block</div>;
        },
        dataIndex: 'block_button',
        key: 'block_button',
        width: 80,
        render(text, record) {
          return {
            children: <BlockButton user={record} />,
          };
        }
      },
      {
        title: () => {
          return <div style={{ fontSize: "10px", fontWeight: "bold" }}>Delete</div>;
        },
        dataIndex: 'delete_button',
        key: 'delete_button',
        width: 80,
        render(text, record) {
          return {
            children: <DeleteButton user={record} />,
          };
        }
      }

    ];

    return columns;
  }

  return (
    <div className={styles.table_container_style}>
      <Table
        pagination={false}
        columns={getColumns()}
        dataSource={getUserTableData()}
        rowKey="id"
      />
    </div>
  )
}

export default UserTable;
